import Vue from 'vue';

export const WINDOW_FOCUS = "window:focus";

Vue.mixin({
  methods: {
    $emitError: function(eventName, ...args) {
      this.$emit(eventName+':ERROR', ...args);
    },
    $onError: function(eventName, ...args) {
      this.$on(eventName+':ERROR', ...args);
    },
    $offError: function(eventName, ...args) {
      this.$off(eventName+':ERROR', ...args);
    }
  }
})

var EventBus = new Vue();

// when tab/window becomes active, emit vue event; (the opposite event is 'blur', but isn't needed atm)
window.addEventListener('focus', function() {
  EventBus.$emit(WINDOW_FOCUS);
});

export default EventBus;
